import React from 'react'
import { graphql } from 'gatsby'
import PageBuilder from '../components/pageBuilder'
import SEO from '../components/seo'
import Helmet from 'react-helmet'

export const query = graphql`
  query PressePageQuery {
    kontaktPage: sanityPage(slug: { current: { eq: "presse" } }) {
      id
      title
      ...PageBuilder
    }
  }
`

const PressePage = props => {
  const { data, errors } = props
  const pageData = data && data.kontaktPage
  return (
    <>
      <Helmet
        bodyAttributes={{
          class: 'is-page-presse',
        }}
      />
      {pageData && pageData.title && <SEO title={pageData.title} />}
      {pageData && (
        <PageBuilder
          pageBuilder={pageData.pageBuilder}
          _rawPageBuilder={pageData._rawPageBuilder}
        />
      )}
    </>
  )
}

export default PressePage
